import { Directive } from "vue";

type AppFitCanvasToContainerMode = undefined | "width-only" | "height-only";

export const appFitCanvasToContainerDirective: Directive<
    HTMLCanvasElement & {
        _appFitCanvasToCntainerUpdateSize: (mode: AppFitCanvasToContainerMode) => void;
        _appFitCanvasToCntainerDisposer: () => void;
    },
    AppFitCanvasToContainerMode
> = {
    mounted(el, bindings) {
        const updateSize = (mode: AppFitCanvasToContainerMode) => () => {
            const { height, width } = (
                el.parentNode as HTMLElement
            ).getBoundingClientRect();

            switch (mode) {
                case "width-only":
                    el.width = width;
                    el.style.width = `${width}px`;
                    break;
                case "height-only":
                    el.height = height;
                    el.style.height = `${height}px`;
                    break;
                default:
                    el.width = width;
                    el.style.width = `${width}px`;
                    el.height = height;
                    el.style.height = `${height}px`;
            }
        };

        let updateSize_ = updateSize(bindings.value);

        updateSize_();

        const observer = new ResizeObserver(updateSize_);

        if (el.parentElement) {
            observer.observe(el.parentElement);
        }

        el._appFitCanvasToCntainerUpdateSize = (mode: AppFitCanvasToContainerMode) => {
            updateSize_ = updateSize(mode);
        };

        el.parentNode?.addEventListener("resize", updateSize_);
        window.addEventListener("resize", updateSize_);

        el._appFitCanvasToCntainerDisposer = () => {
            observer.disconnect();
            window.removeEventListener("resize", updateSize_);
            el.parentNode?.removeEventListener("resize", updateSize_);
        };
    },
    unmounted(el) {
        el._appFitCanvasToCntainerDisposer();
    },
    updated(el, bindings) {
        el._appFitCanvasToCntainerUpdateSize(bindings.value);
    },
};
